// NPM Imports
import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { connect } from "react-redux";
import { Button, Toastr } from "../../revvComponents";
import { DATA_PLAYFIELD } from "../../constants";
import { IntegrationsActions } from "../../actions";
import { GlobalUtils } from "../../utils";

const { authenticateCRMUser, getCRMUserData, CRMCallbackUser } =
  IntegrationsActions;
const { CRM_SHORT_NAMES_MAPPING } = DATA_PLAYFIELD;
const { writeDataToLocalStorage } = GlobalUtils;

class SelectDataSourcePopup extends Component {
  state = {
    clientId:
      this.props.config && this.props.config.clientId
        ? this.props.config.clientId
        : "",
    clientSecret:
      this.props.config && this.props.config.clientSecret
        ? this.props.config.clientSecret
        : "",
    redirectUrl:
      this.props.config && this.props.config.redirectUrl
        ? this.props.config.redirectUrl
        : `${window.location.origin}/datastudio/${this.props.data.name}/callback`,
    instanceUrl:
      this.props.config.instanceUrl && this.props.config
        ? this.props.config.instanceUrl
        : "",
    scopes:
      this.props.config && this.props.config.scopes
        ? this.props.config.scopes
        : "crm.lists.read crm.objects.contacts.read crm.schemas.contacts.read crm.objects.companies.read crm.objects.deals.read crm.schemas.companies.read crm.schemas.deals.read crm.objects.owners.read crm.objects.custom.read crm.objects.custom.write crm.schemas.custom.read",
    isDisabled: true,
    showAuthBtnLoader: false,
  };

  componentDidMount() {
    const { clientId, clientSecret, redirectUrl, instanceUrl, scopes } =
      this.props.config;
    if (clientId && clientSecret && redirectUrl) {
      this.setState({
        clientId,
        clientSecret,
        redirectUrl,
        instanceUrl,
        scopes,
      });
    } else {
      this._onCRMInit();
    }
  }

  // get CRM data
  _onCRMInit = () => {
    this.props
      .getCRMUserData(CRM_SHORT_NAMES_MAPPING[this.props.data.name])
      .then(response => {
        const crmUserConfig = response.CRMConfig.crm;

        // check if the authenticated crm is a current open crm
        if (
          crmUserConfig.crm === CRM_SHORT_NAMES_MAPPING[this.props.data.name]
        ) {
          this.setState({
            clientId: crmUserConfig.client_id,
            clientSecret: crmUserConfig.client_secret,
            redirectUrl: crmUserConfig.redirect_url,
            instanceUrl: crmUserConfig.instance_url,
          });
        }
      })
      .catch(() => {
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: "This is an error",
          timeout: 3000,
        });
      });
  };

  // toggle Authenticate Button loader handler
  _toggleAuthBtnLoader = flag => {
    this.setState({ showAuthBtnLoader: flag });
  };

  _checkAuthenticateChanges = state => {
    const { clientId, clientSecret, redirectUrl } = this.props.config;
    if (
      state.clientId.trim() === clientId &&
      state.clientSecret.trim() === clientSecret &&
      state.redirectUrl.trim() === redirectUrl
    ) {
      this.setState({ isDisabled: true });
    } else {
      this.setState({ isDisabled: false });
    }
  };

  _onInputChangeHandler = e => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => this._checkAuthenticateChanges(this.state),
    );
  };

  _isFormEmpty = state =>
    state.clientId.trim() &&
    state.clientSecret.trim() &&
    state.redirectUrl.trim();

  _onAuthenticateHandler = () => {
    const { instanceUrl, redirectUrl, clientId, clientSecret, scopes } =
      this.state;

    writeDataToLocalStorage("templateRedirectUrl", window.location.href);

    const config = {
      crm: CRM_SHORT_NAMES_MAPPING[this.props.data.name],
      instance_url: instanceUrl ? instanceUrl.trim() : "",
      redirect_url: redirectUrl ? redirectUrl.trim() : "",
      client_id: clientId ? clientId.trim() : "",
      client_secret: clientSecret ? clientSecret.trim() : "",
      scopes: scopes ? scopes.trim() : "", // TODO: add this for hubspot
    };

    this._toggleAuthBtnLoader(true);
    this.props
      .authenticateCRMUser(config)
      .then(() => {})
      .catch(() => {
        this._toggleAuthBtnLoader(false);
        Toastr.showToastr({
          type: "failure",
          // message: handleApiErrMsg(error),
          message: "Couldnot authenticate the config",
          timeout: 3000,
        });
      });
  };

  _onClose = () => {
    this.props.closePopup();
  };

  render() {
    const { isAuthenticated, instanceUrl } = this.props.config;
    const { data } = this.props;
    const crmInstanceUrl = instanceUrl || "";

    return (
      <Modal open onClose={this._onClose} closeOnOverlayClick={false} center>
        <Fragment>
          <div>
            <div className="modal-heading">{`Authenticate ${data.name} connection`}</div>
            <div className="modal-body">
              <span className="settings-heading">
                Configure integration settings
              </span>
              <span className="settings-label">Instance URL</span>
              <input
                className="form-control settings-md-inputs"
                type="text"
                value={this.state.instanceUrl || crmInstanceUrl}
                disabled
              />
              <span className="settings-label">Redirect URL</span>
              <input
                className="form-control settings-md-inputs"
                type="text"
                value={this.state.redirectUrl}
                name="redirectUrl"
                onChange={this._onInputChangeHandler}
                data-test="oauthbasedcrm-redirect-url-input"
                disabled
              />
              <span className="settings-label">Client ID</span>
              <input
                className="form-control settings-md-inputs"
                type="text"
                value={this.state.clientId}
                name="clientId"
                onChange={this._onInputChangeHandler}
                data-test="oauthbasedcrm-clientid-input"
              />
              <span className="settings-label">Client Secret</span>
              <input
                className="form-control settings-md-inputs"
                type="text"
                value={this.state.clientSecret}
                name="clientSecret"
                onChange={this._onInputChangeHandler}
                data-test="oauthbasedcrm-client-secret-input"
              />
              {data.scopes && (
                <span className="settings-label">Client Scope</span>
              )}
              {data.scopes && (
                <input
                  className="form-control settings-md-inputs"
                  type="text"
                  value={this.state.scopes}
                  name="scopes"
                  onChange={this._onInputChangeHandler}
                  data-test="oauthbasedcrm-client-secret-input"
                  disabled
                />
              )}
            </div>

            <div className="modal-footer">
              <Button
                className="btn btn-transparent modal-footer-btn cancle-btn"
                data-test="table-gsheet-popup-cancle-btn"
                onClick={this._onClose}>
                Cancel
              </Button>
              <Button
                type="four"
                disabled={
                  !this._isFormEmpty(this.state) ||
                  (isAuthenticated && this.state.isDisabled)
                }
                isLoading={this.state.showAuthBtnLoader}
                className="btn btn-primary"
                onClick={this._onAuthenticateHandler}
                data-test="oauthbasedcrm-authenticate-btn">
                <FontAwesomeIcon icon={["far", "shield-alt"]} />
                &nbsp;
                {isAuthenticated && this.state.isDisabled
                  ? "Authenticated"
                  : "Authenticate"}
              </Button>
            </div>
          </div>
        </Fragment>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  authenticateCRMUser,
  getCRMUserData,
  CRMCallbackUser,
};

export default connect(null, mapDispatchToProps)(SelectDataSourcePopup);
